<template>
  <section class="summary">
    <div class="inner">
      <paragraph-header size="2">{{ $t('Summary') }}</paragraph-header>
      <div class="box" ref="box" :style="{ minHeight: `${boxHeight}px` }">
        <div class="col var_wide hidden_content" :class="{ is_visible: !waitingForReservation }">
          <paragraph-header size="4">{{ $t('Your Products') }}</paragraph-header>
          <ul>
            <li v-for="product in orderableProducts" :key="`product_${product.id}`">
              <span class="number">{{ product.quantity }}</span>
              <span class="name">{{ getProductSimpleName(product) }}</span>
              <span class="price">{{ getProductPrice(product.id) | currency(product.currency) }}</span>
            </li>
            <li v-for="product in deliveryProduct" :key="`product_${product.id}`">
              <span class="number">{{ product.quantity }}</span>
              <span class="name">{{ product.translated_name || product.name }}</span>
              <span class="price">{{ getProductPrice(product.id) | currency(product.currency) }}</span>
            </li>
            <li v-for="product in deposit" :key="`product_${product.id}`">
              <span class="number">&nbsp;</span>
              <span class="name">{{ product.translated_name || product.name }}</span>
              <span class="price">{{ getProductPrice(product.id) | currency(product.currency) }}</span>
            </li>
            <li class="var_sum">
              <span class="number"></span>
              <span class="name"></span>
              <span class="price">{{ sumPrice | currency(currentCurrency) }}</span>
            </li>
          </ul>
          <!-- <span class="coupon">
            <div class="field var_70">
              <input
                id="vouchercode"
                type="text"
                :class="{ is_filled: voucherCode }"
                v-model="voucherCode"
                :disabled="fetchingDataFromVoucherCode"
              />
              <label for="vouchercode">{{ $t('Voucher Code') }}</label>
            </div>
            <div class="field">
              <app-button @click="applyVoucher">{{ $t('Apply') }}</app-button>
            </div>
          </span> -->
        </div>
        <div class="col hidden_content" :class="{ is_visible: !waitingForReservation }">
          <div class="block">
            <span class="header">
              <svg width="18" height="18" viewbox="0 0 18 18 ">
                <use xlink:href="#calendar"></use>
              </svg>
              <paragraph-header size="4">{{ $t('Date') }}</paragraph-header>
            </span>
            <div class="content">
              <p>
                {{ startDate | date }}<br />
                {{ amountOfWeeks }} {{ $tc('weeks', amountOfWeeks) }}
              </p>
            </div>
          </div>
          <div class="block var_icon" v-if="deliveryType === 'delivery'">
            <span class="header">
              <svg width="16" height="22" viewbox="0 0 30 42">
                <use xlink:href="#pin"></use>
              </svg>
              <paragraph-header size="4">{{ $t('shippingAddress') }}</paragraph-header>
            </span>
            <div class="content" v-if="formattedShippingAddress.length > 1">
              <p>{{ formattedShippingAddress[0] }}<br />{{ formattedShippingAddress[1] }}</p>
              <p v-if="shippingNote">{{ shippingNote }}</p>
            </div>
          </div>
          <div class="block var_icon" v-if="deliveryType === 'delivery'">
            <span class="header">
              <svg width="16" height="22" viewbox="0 0 30 42">
                <use xlink:href="#pin"></use>
              </svg>
              <paragraph-header size="4">{{ $t('pickupAddress') }}</paragraph-header>
            </span>
            <div class="content" v-if="formattedPickUpAddress.length > 1">
              <p>{{ formattedPickUpAddress[0] }}<br />{{ formattedPickUpAddress[1] }}</p>
              <p v-if="pickupNote">{{ pickupNote }}</p>
            </div>
          </div>
          <div class="block var_icon" v-if="deliveryType === 'pickup' && selectedStorage">
            <span class="header">
              <svg width="16" height="22" viewbox="0 0 30 42">
                <use xlink:href="#pin"></use>
              </svg>
              <paragraph-header size="4">{{ $t('Pickup place details') }}</paragraph-header>
            </span>
            <div class="content">
              <p>{{ selectedStorage.brand }}</p>
              <p v-html="selectedStorage.location"></p>

              <p class="hours_block">
                <span
                  class="hours_row"
                  v-for="cur in selectedStorage.openHours"
                  :key="cur.day"
                  :class="{ pickup_day: cur.day === pickupDateName }"
                >
                  <span class="hours_label">{{ $t(cur.day) }}</span>
                  <span v-html="cur.time"></span>
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col hidden_content" :class="{ is_visible: !waitingForReservation }">
          <div class="block">
            <paragraph-header size="4">{{ $t('billingAddress') }}</paragraph-header>
            <div class="content">
              <p>{{ $t(salutation) }} {{ firstName }} {{ lastName }}</p>
              <p v-if="company">{{ company }}</p>
              <p>
                {{ address }}
                {{ postCode }} {{ city }}<br />
                {{ country }}
              </p>
            </div>
          </div>
          <div class="block">
            <paragraph-header size="4">{{ $t('Contact Information') }}</paragraph-header>
            <div class="content">
              <p>{{ emailAddress }}<br />{{ mobile }}</p>
            </div>
          </div>
          <div class="block" v-if="notes">
            <paragraph-header size="4">{{ $t('Additional Information') }}</paragraph-header>
            <div class="content">
              <p>{{ notes }}</p>
            </div>
          </div>
        </div>

        <the-loader v-if="waitingForReservation" :isAbsolute="true"></the-loader>
      </div>
    </div>
  </section>
</template>

<script>
import date from '../../helpers/date-and-time'
import CHF from '../../helpers/currency'
import { EUR } from '../../helpers/currency'
import { mapGetters, mapState } from 'vuex'
import TheLoader from './TheLoader.vue'
import ParagraphHeader from '../atoms/ParagraphHeader.vue'
// import AppButton from '../atoms/AppButton.vue'
export default {
  components: { ParagraphHeader, TheLoader },
  data() {
    return {
      boxHeight: 300,
      waitingForReservation: true,
      fetchingDataFromVoucherCode: false,
    }
  },
  computed: {
    ...mapState('cart', ['startDate', 'amountOfWeeks', 'deliveryType', 'deliveryProduct', 'reservationsResponse']),
    ...mapState('user', [
      'shippingNote',
      'pickupNote',

      'salutation',
      'firstName',
      'lastName',

      'company',
      'address',
      'city',
      'postCode',
      'country',

      'emailAddress',
      'mobile',

      'notes',
    ]),
    ...mapGetters('user', ['shippingAddress', 'pickupAddress']),
    ...mapState('products', { deposit: 'deposit', baseProducts: 'base' }),
    ...mapGetters('storages', ['selectedStorage']),
    ...mapGetters('cart', ['orderableProducts']),
    voucherCode: {
      set(value) {
        this.$store.commit('cart/setVoucherCode', value)
      },
      get() {
        return this.$store.state.cart.voucherCode
      },
    },
    formattedShippingAddress() {
      return this.shippingAddress.split(',')
    },
    formattedPickUpAddress() {
      return this.pickupAddress.split(',')
    },
    pickupDateName() {
      const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      return days[this.startDate.getDay()]
    },
    currentCurrency() {
      return this.orderableProducts[0].currency
    },
    sumPrice() {
      if (!this.reservationsResponse) return 0

      return this.reservationsResponse.reduce((acc, curr) => {
        return (acc += +curr.data.total_price)
      }, 0)
    },
  },
  methods: {
    getProductPrice(id) {
      const product = this.reservationsResponse.find((v) => v.data.resource_id == id)
      return +product?.data.total_price
    },
    getProductSimpleName(product) {
      const parentProduct = this.baseProducts.find((v) => v.id == product.properties.main_product_id)
      if (parentProduct) return parentProduct.name
      const pr = this.orderableProducts.find((v) => v.id == product.id)
      return pr?.translated_name || pr.name
    },
    calcBoxHeight() {
      const sizes = this.$refs.box.getBoundingClientRect()
      const bottomBarSize = 80

      this.boxHeight = Math.max(0.5 * window.innerHeight, window.innerHeight - sizes.y - bottomBarSize)
    },
    async makeReservation() {
      this.waitingForReservation = true
      this.showOverlay = true
      const resp = await this.$store.dispatch('cart/makeReservation')

      this.$store.commit('cart/setReservationsResponse', resp)

      this.waitingForReservation = false
    },
  },

  created() {
    window.addEventListener('resize', this.calcBoxHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.calcBoxHeight)
  },
  async mounted() {
    this.calcBoxHeight()
    await this.makeReservation()
  },
  filters: {
    date(value) {
      if (!value) return ''
      return date.format(value, 'ddd DD MMM YYYY')
    },
    currency(value, currency = 'CHF') {
      if (!value) return ''

      if (currency === 'EUR') {
        return EUR(value).format()
      }

      return CHF(value).format()
    },
  },
}
</script>

<style lang="scss" scoped>
.summary {
  display: block;
  width: 100%;

  .inner {
    @include container();
  }

  .box {
    position: relative;
    display: block;
    margin-top: 25px;
    border-radius: 5px 5px 0 0;

    background: $colorWhite;
    padding: 25px 2% 75px;
    display: flex;
    flex-wrap: wrap;

    .col {
      flex: 1 1 200px;
      margin: 50px 3% 0;

      &.var_wide {
        // @include mq($from: desktop) {
        flex: 1 1 350px;
        // }

        h4 {
          padding-left: 20px;
        }
      }
    }

    .hidden_content {
      opacity: 0;
      transition: opacity 0.3s;

      &.is_visible {
        opacity: 1;
      }
    }
  }

  .coupon {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .field {
    position: relative;
    flex: 0;

    &.var_70 {
      flex: 0 0 calc(70% - 30px);
    }
  }
}

ul {
  list-style: none;
  margin: 17px 0 0 0;
  padding: 0;

  li {
    @include fontStyleCopyRegular;
    padding: 6px 20px;
    display: flex;

    &:nth-child(2n + 1) {
      background: $colorBeige;
    }

    &.var_sum {
      background: $colorWhite;
      border-top: 1px solid $colorBlack;
      padding-top: 20px;
    }

    .number {
      flex: 0 0 50px;
      padding-right: 20px;
    }

    .name {
      flex: 1 1 auto;
    }

    .price {
      flex: 0 0 130px;
      padding-right: 20px;
      text-align: right;
    }
  }
}

.block {
  @include fontStyleCopyRegularListing;
  margin-bottom: 45px;

  &:last-child {
    margin-bottom: 0;
  }

  p {
    margin-top: 10px;
  }

  .var_icon {
    .content {
      padding-left: 30px;
    }
  }

  .header {
    display: flex;
    align-items: flex-end;

    svg {
      margin-bottom: 5px;
      margin-right: 10px;
    }
  }
}

.hours_block {
  display: inline-block;
  margin-top: 5px;
  font-size: 12px;
}

.hours_label {
  display: inline-block;
  min-width: 80px;
}

.hours_row {
  display: flex;

  & > * {
    position: relative;
    z-index: 3;
  }

  &.pickup_day {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: -3px;
      left: -5px;
      width: calc(100% + 10px);
      height: calc(100% + 6px);
      background: $colorBeige;
      z-index: 1;
    }
  }
}
</style>
